module.exports = __webpack_public_path__ + "img/28bb0d44579bdbaff870cbcc65daa42c.gif";